import { protocolTypes } from '../config/common'

var keyByValue = function(value) {

    var kArray = Object.keys(protocolTypes);        
    var vArray = Object.values(protocolTypes);      
    var vIndex = vArray.indexOf(value);        

    return kArray[vIndex];                      
}



const RoutingRuleRetainer = function(payload) {

    this.rrdef = payload.orgRrdef;
    this.targetProtocol = payload.protocol;	
    this.delegate = payload.delegate;
    this.ttype = payload.ttype;
    this.orgProtocol = payload.orgProtocol;

    if(this.rrdef === undefined || this.rrdef === null || this.rrdef === "") return


    if(this.targetProtocol === this.orgProtocol){

        return {
            ...this.rrdef,
            attributes: { ...this.rrdef.attributes, delegate: this.delegate, ttype: this.ttype }
        }
    }

    const protocolName = keyByValue(payload.protocol)

    const newRrdefAttributes = this[protocolName]();

    const newRrdef = {
        name: this.rrdef.name,
        id: this.rrdef.id,
        type: this.rrdef.type,
        attributes: { 
            delegate: this.delegate,
            dir: this.rrdef.attributes.dir,
            tcmd: this.rrdef.attributes.tcmd,
            ttype:  this.ttype,
            ...newRrdefAttributes
        }
    }

    return newRrdef;
}


RoutingRuleRetainer.prototype.http = function() {

    const attributes = {
        
        commandtype: this.rrdef.attributes.commandtype ? this.rrdef.attributes.commandtype : "",
        path: this.rrdef.attributes.path ? this.rrdef.attributes.path : "",
        code: this.rrdef.attributes.code ? this.rrdef.attributes.code : "",
       
    }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance
        attributes.op = this.rrdef.attributes.op ? this.rrdef.attributes.op : ""
    }

    if(this.rrdef.attributes.dir === 'OUT'){
        attributes.host = this.rrdef.attributes.host ? this.rrdef.attributes.host : ""
    }

    return attributes;

}

RoutingRuleRetainer.prototype.http2 = function() {

    const attributes = {
        
        commandtype: this.rrdef.attributes.commandtype ? this.rrdef.attributes.commandtype : "",
        path: this.rrdef.attributes.path ? this.rrdef.attributes.path : "",
        code: this.rrdef.attributes.code ? this.rrdef.attributes.code : "",
       
    }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance
        attributes.op = this.rrdef.attributes.op ? this.rrdef.attributes.op : ""
    }

    if(this.rrdef.attributes.dir === 'OUT'){
        attributes.host = this.rrdef.attributes.host ? this.rrdef.attributes.host : ""
    }

    return attributes;

}


RoutingRuleRetainer.prototype.mqtt = function() {

    const attributes = {
               
        type: this.rrdef.attributes.type ? this.rrdef.attributes.type : "",
       
    }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance
        attributes.topic = this.rrdef.attributes.topic ? this.rrdef.attributes.topic : ""
    }

    return attributes

}

RoutingRuleRetainer.prototype.diameter = function() {

    const attributes = {
        
        commandtype: this.rrdef.attributes.commandtype ? this.rrdef.attributes.commandtype : "",
        commandcode: this.rrdef.attributes.commandcode ? this.rrdef.attributes.commandcode : "",
       
    }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance
        attributes.vendorid = this.rrdef.attributes.vendorid ? this.rrdef.attributes.vendorid : ""

    }

    return attributes

}

RoutingRuleRetainer.prototype.radius = function() {

    const attributes = {
        
        commandtype: this.rrdef.attributes.commandtype ? this.rrdef.attributes.commandtype : "",
        commandcode: this.rrdef.attributes.commandcode ? this.rrdef.attributes.commandcode : "",
       
    }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance
    }

    return attributes;

}

RoutingRuleRetainer.prototype.asn1 = function() {

    const attributes = {   }

    if(this.rrdef.attributes.dir === 'IN'){
        attributes.tinstance = this.rrdef.attributes.tinstance;
        attributes.type = this.rrdef.attributes.type ? this.rrdef.attributes.type : "";
        attributes.nastype = this.rrdef.attributes.nastype ? this.rrdef.attributes.nastype : ""

    }

    return attributes;

}
    
export default RoutingRuleRetainer;
